/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 详情页获取优惠券列表
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  productId: number,
  productTypeId: string,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: Array<good.ProductCouponDto>;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/good/coupons/product/${productId}/${productTypeId}`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
